/* eslint-disable @typescript-eslint/no-shadow */
import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { combineLatest, Observable, Subject, map } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadInsightSuccess } from '../../../redux';
import { InsightsState } from '../../../redux';
import { ViewInsightComponent } from '../view-insight.component';

@Component({
  selector: 'app-insight-modal-container',
  template: '',
  standalone: false
})
export class ModalContainerInsightComponent implements OnDestroy, OnInit {
  // This is only used when you enter URL of specific insight with ID.
  public insightsActive$: Observable<any[]> = inject(Store).select(InsightsState.insightsActive);
  public insightsInactive$: Observable<any[]> = inject(Store).select(InsightsState.insightsInactive);
  private unsubscribe: Subject<void> = new Subject();

  public currentDialog = null;
  public tableData;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private actions$: Actions
  ) {}

  public ngOnInit() {
    combineLatest([this.insightsActive$, this.insightsInactive$])
      .pipe(
        map(([active, inactive]) => [...active, ...inactive]),
        takeUntil(this.unsubscribe)
      )
      .subscribe((data) => (this.tableData = data));
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      const found = this.tableData.find((element) => element.id === Number(params.id));

      if (found) {
        this.dialogService
          .open(ViewInsightComponent, {
            closeOnEsc: false,
            closeOnBackdropClick: false,
            context: {
              insight: found
            }
          })
          .onClose.subscribe((data) => {
            this.router.navigateByUrl('insights/active');
          });
      } else {
        this.actions$.pipe(ofActionSuccessful(LoadInsightSuccess), takeUntil(this.unsubscribe)).subscribe((data) => {
          const found = this.tableData.find((element) => element.id === params.id);
          this.dialogService
            .open(ViewInsightComponent, {
              closeOnEsc: false,
              closeOnBackdropClick: false,
              context: {
                insight: found
              }
            })
            .onClose.subscribe((data) => {
              this.router.navigateByUrl('insights/active');
            });
        });
      }
    });
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
